import React from 'react';
import { trustedLogos } from '../data/mock';
import { motion } from 'framer-motion';

const TrustedBySection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl md:text-3xl font-bold text-center mb-12"
        >
          Trusted By <span className="text-[#2563EB]">Leading Retailers</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-3 md:grid-cols-6 gap-8 items-center justify-items-center"
        >
          {trustedLogos.map((logo, idx) => (
            <div key={idx} className="flex items-center justify-center h-16 w-full">
              <img
                src={logo.url}
                alt={logo.name}
                className="max-h-12 max-w-[140px] object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustedBySection;
